import { EviteModal } from './index'
import urls from 'urls';

// Example simple usage:
//
//  delete_modal = new ModalDialog
//    title:      'Delete Group'
//    body:       'Are you sure you wish to delete this group?'
//    buttons:    ['Cancel', 'Delete Group']
//    onResponse: (response) ->
//      if response.index == 1
//        console.log 'delete group'
//  delete_modal.show()

class ModalDialog {

  settings = {
    url: urls.get('modal_dialog'),
    buttons: ['Cancel', 'Yes'],
    title: null,
    html: false,
    width: "480px",
    dialog: {},
  };

  constructor(settings) {
    if (!this.settings.url_parameters) {
      this.settings.url_parameters = {}
    }
    this.settings.url_parameters.dialog = {
      body: settings.body || '',
      title: settings.title || this.settings.title,
      buttons: settings.buttons || this.settings.buttons,
      html: settings.html || this.settings.html,
    };
    return new EviteModal(Object.assign({}, this.settings, settings))
  };

}

export default ModalDialog


// WEBPACK FOOTER //
// ./assets/es6/modal/dialog_modal.es6